import React from 'react';
import { ChevronUp } from './vector-groups/_chevron-up';
import { ChevronDown } from './vector-groups/_chevron-down';
import { Minus } from './vector-groups/_minus';
import { Plus } from './vector-groups/_plus';
import { Checkmark } from './vector-groups/_checkmark';
import { Cog } from './vector-groups/_cog';
import { Filter } from './vector-groups/_filter';
import { Close } from './vector-groups/_close';
import { Bin } from './vector-groups/_bin';
import { Facebook } from './vector-groups/_brand-facebook';
import { Instagram } from './vector-groups/_brand-instagram';
import { Computer } from './vector-groups/_computer';
import { FilePdf } from './vector-groups/_file-pdf';
import { DesignMug } from './vector-groups/_design-mug';
import { Image } from './vector-groups/_image';
import { ImageSet } from './vector-groups/_image-set';
import { FontStyleBold } from './vector-groups/_font-style-bold';
import { FontStyleItalic } from './vector-groups/_font-style-italic';
import { FontStyleUnderline } from './vector-groups/_font-style-underline';
import { AlignLeft } from './vector-groups/_paragraph-align-left';
import { AlignCenter } from './vector-groups/_paragraph-align-center';
import { AlignRight } from './vector-groups/_paragraph-align-right';
import { LineHeight } from './vector-groups/_paragraph-height';
import { TextStyle } from './vector-groups/_text-style';
import { AlertCircle } from './vector-groups/_alert-circle';
import { AlertTriangle } from './vector-groups/_alert-triangle';
import { CheckCircle } from './vector-groups/_check-circle';
import { ThreeSixty } from './vector-groups/_three-sixty';
import { ThreeDimensional } from './vector-groups/_three-dimensional';
import { Expand } from './vector-groups/_expand';
import { Shrink } from './vector-groups/_shrink';
import { ImageFileAdd } from './vector-groups/_image-file-add';
import { ImageFileCheck } from './vector-groups/_image-file-check';
import { ChevronRight } from './vector-groups/_chevron-right';
import { TextBar } from './vector-groups/_text-bar';

export type IconNames = keyof typeof Icons;
export const Icons = {
    'general-ui-chevron-up': <ChevronUp />,
    'general-ui-chevron-right': <ChevronRight />,
    'general-ui-chevron-down': <ChevronDown />,
    'general-ui-minus': <Minus />,
    'general-ui-plus': <Plus />,
    'general-ui-checkmark': <Checkmark />,
    'general-ui-cog': <Cog />,
    'general-ui-filter': <Filter />,
    'general-ui-close': <Close />,
    'general-ui-bin': <Bin />,
    'general-ui-expand': <Expand />,
    'general-ui-shrink': <Shrink />,

    'alert-circle-exclamation': <AlertCircle />,
    'alert-triangle-exclamation': <AlertTriangle />,
    'alert-circle-check': <CheckCircle />,

    'upload-from-facebook': <Facebook />,
    'upload-from-instagram': <Instagram />,
    'upload-from-computer': <Computer />,
    'upload-from-file': <FilePdf />,

    'image-file-add': <ImageFileAdd />,
    'image-file-check': <ImageFileCheck />,

    'option-design': <DesignMug />,
    'option-image': <Image />,
    'option-image-set': <ImageSet />,

    'bold': <FontStyleBold />,
    'italic': <FontStyleItalic />,
    'underline': <FontStyleUnderline />,
    'align-left': <AlignLeft />,
    'align-center': <AlignCenter />,
    'align-right': <AlignRight />,
    'line-height': <LineHeight />,
    'text-style': <TextStyle />,
    'text-bar': <TextBar />,

    'three-sixty': <ThreeSixty />,
    'three-dimensional': <ThreeDimensional />
};
